import { render, staticRenderFns } from "./Buying.vue?vue&type=template&id=004d54fe&scoped=true&"
import script from "./Buying.vue?vue&type=script&lang=ts&"
export * from "./Buying.vue?vue&type=script&lang=ts&"
import style0 from "./Buying.vue?vue&type=style&index=0&id=004d54fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d54fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
